// src/components/CollapsiblePanel.jsx

import React, { useState } from "react";
import "./ProjectsWriting.css";

const CollapsiblePanel = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`panel ${isOpen ? "open" : "closed"}`}>
      <div className="panel-header clickable" > {/*onClick={() => setIsOpen(!isOpen)}>*/}
        <h3>{title}</h3>
      </div>
      {isOpen && <div className="panel-content">{content}</div>}
    </div>
  );
};

export default CollapsiblePanel;
